/**
 * @file Homepage Hero
 */

import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Homepage Hero component
 */
const vHpHero = () => {
	const hpHero = document.querySelector( '.v-hp-hero' );

	if ( ! hpHero ) {
		return;
	}

	gsap.registerPlugin( CustomEase, ScrollTrigger );
	const noChart = ! document.querySelector( '.v-hp-hero__chart-wrap ' );
	// const mobile  = matchMedia( '(max-width: 550px)' );

	gsap.to( '.v-hp-hero__content', {
		opacity:       1,
		y:             0,
		duration:      .6,
		ease:          'sine.out',
		scrollTrigger: {
			trigger: '.v-hp-hero__content-wrap',
			start:   '50% bottom',
		},
		onUpdate() {
			if ( noChart ) {
				return;
			}

			if ( this.progress() > .5 && ! chartEntrance ) {
				enterChart();
			}
		},
	} );

	// Bail out if no chart
	if ( noChart ) {
		return;
	}

	const newEase              = CustomEase.create( 'inout', 'M0,0,C0.532,0,0.816,1,1,1' );
	let chartEntrance;
	let nextAnimationTriggered = false;

	const graphNumber = hpHero.querySelector( '.v-credit-graph__number' );

	/**
	 * Entrance for chart
	 */
	const enterChart = () => {
		chartEntrance = gsap.timeline( {
			defaults: {
				ease:     'sine.out',
				duration: .9,
			},
			scrollTrigger: {
				trigger: '.v-hp-hero__chart-wrap',
				start:   '33.3333% bottom',
			},
			onComplete() {
				setTimeout( animateChart, 500 );
			},
		} )
			.to( '.v-hp-hero__chart', {
				opacity:  1,
				y:        0,
				duration: .6,
				onUpdate() {
					if ( this.progress() > .5 && ! nextAnimationTriggered ) {
						nextAnimationTriggered = true;
						document.dispatchEvent( new CustomEvent( 'vChartAnimated' ) );
					}
				},
			}, '>-50%' )
			.to( '.v-hp-hero__label--low', {
				opacity:  1,
				y:        0,
				duration: .4,
			}, '>-.2' );
	};

	/**
	 * Animation for chart
	 */
	const animateChart = () => {
		gsap.timeline( {
			defaults: {
				ease:     'sine.out',
				duration: .9,
			},
			scrollTrigger: {
				trigger: '.v-hp-hero__chart-wrap',
				start:   'bottom bottom',
			},
			onComplete() {
				const high = hpHero.querySelector( '.v-hp-hero__label--high' );
				high.classList.add( 'v-hp-hero__label--entered' );
				high.removeAttribute( 'style' );
			},
		} )
			.addLabel( 'step-two-start' )
			.to( '.v-hp-hero__circle .v-credit-graph__mask', {
				'--circle-progress': '160deg',
			}, 'step-two-start' )
			.to( graphNumber, {
				textContent: graphNumber.dataset.mid,
				snap:        { textContent: 1 },
			}, '<' )
			.to( '.v-hp-hero__label--low', {
				opacity:  0,
				y:        10,
				duration: .4,
				onComplete() {
					gsap.set( '.v-hp-hero__label--low', { display: 'none' } );
					gsap.set( '.v-hp-hero__label--mid', { display: 'block', opacity: 0 } );
				},
			}, '<' )
			.to( '.v-hp-hero__user', {
				rotate:   -10,
				duration: .65,
				ease:     newEase,
			}, '<' )
			.to( '.v-hp-hero__user-outer', {
				xPercent: 50,
				x:        0,
				duration: .7,
				ease:     newEase,

			}, '<' )
			.to( '.v-hp-hero__user', {
				rotate:   0,
				duration: .25,
				ease:     'back.out(5)',
			}, '>-.05' )
			.to( '.v-hp-hero__label--mid', {
				opacity:  1,
				y:        0,
				duration: .4,
			}, '>-.4' )
			.addLabel( 'step-three-start', '>+1' )
			.to( '.v-hp-hero__circle .v-credit-graph__mask', {
				'--circle-progress': '250deg',
				duration:            .8,
			}, 'step-three-start' )
			.to( graphNumber, {
				textContent: graphNumber.dataset.high,
				duration:    .8,
				snap:        { textContent: 1 },
			}, '<' )
			.to( '.v-hp-hero__label--mid', {
				opacity:  0,
				y:        10,
				duration: .4,
				onComplete() {
					gsap.set( '.v-hp-hero__label--mid', { display: 'none' } );
					gsap.set( '.v-hp-hero__label--high', { display: 'block', opacity: 0 } );
				},
			}, '<' )
			.to( '.v-hp-hero__user', {
				rotate:   -8,
				duration: .55,
				ease:     newEase,
			}, '<' )
			.to( '.v-hp-hero__user-outer', {
				xPercent: 80,
				x:        0,
				duration: .6,
				ease:     newEase,

			}, '<' )
			.to( '.v-hp-hero__user', {
				rotate:   0,
				duration: .2,
				ease:     'back.out(4.5)',
			}, '>-.05' )
			.to( '.v-hp-hero__label--high', {
				opacity:  1,
				y:        0,
				duration: .4,
			}, '>-.4' )
			.timeScale( .8 );
	};
};

export default vHpHero;
